module.exports = __webpack_public_path__ + "img/Sign_368.82d188c1.png";